/**
 * Said once at the top of a screen whose changes the session may not make
 * (plan §F.5.4, migration 0069): what they may not do, and who can change it.
 *
 * THE RULE, FOR EVERY SCREEN (round 73's SW-2): A CONTROL THE SESSION MAY
 * NOT USE IS HIDDEN, AND THE NOTICE STAYS. Entry points and the small
 * controls inside a table alike -- Rename, an alias's ×, Undo, Remove, Use
 * This Debit -- each behind one `can(...) &&`. A value a control displayed
 * is still shown, as text: a party's roles read "Customer, Vendor" rather
 * than as ticks nobody may change. Until round 73 the small controls were
 * left under this notice, and a viewer's Parties was a table in which every
 * control on every row was a refusal away; a screen whose every control
 * answers "you may not" is one its reader learns to distrust. The notice is
 * what says why the controls are absent, so it is kept where any are hidden.
 * The API is the protection either way.
 */

import type { Capability } from '../api.js';
import { useCan } from '../auth/AuthProvider.js';

export function AccessNotice({ capability, what }: { capability: Capability; what: string }) {
  const can = useCan();
  if (can(capability)) return null;
  return (
    <p role="status" className="notice notice-posted">
      Your access to this business lets you read {what}, not change them. An admin can change that in Settings,
      People.
    </p>
  );
}
